import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import DeepfenceCredentialsForm from "./DeepfenceCredentialsForm";
import DeepfenceConfigListing from "./DeepfenceConfigListing";

export default function DeepfencePullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={DeepfenceCredentialsForm}
      PullConfigListingView={DeepfenceConfigListing}
    />
  );
}
